/* Centauri C12 — Performance metrics. Progressive enhancement only.
   Core content (the 3 stats + divider lines) is fully visible without JS.
   This script draws the divider grid lines on as the section scrolls into view:
   a horizontal rule sweeps LEFT→RIGHT while the vertical column dividers draw
   DOWNWARD simultaneously. Reveal happens once, then the observer disconnects.
   - respects prefers-reduced-motion (lines shown instantly via CSS; we skip priming)
   - handles multiple instances on a page
   - no-ops when the root element is absent */
(function () {
  'use strict';

  // The script is injected per-block, so it can execute once per C12 block on the
  // page. Guard so init runs and document-level listeners attach only once,
  // regardless of how many blocks inject it (avoids a document-listener leak).
  if (window.__centauriC12Init) return;
  window.__centauriC12Init = true;

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function reveal(root) {
    root.classList.add('is-revealed');
  }

  function setup(root) {
    if (root.dataset.centauriMetricsReady === 'true') return;
    root.dataset.centauriMetricsReady = 'true';

    // Reduced motion: leave the lines in their static (final) state — no priming,
    // no draw-on. CSS already neutralizes the transform/transition in this mode.
    if (reduceMotion()) {
      root.classList.add('is-revealed');
      return;
    }

    // Prime: collapse the lines to scale 0 so they can animate in. Done in JS so a
    // no-JS visitor still sees the dividers fully drawn.
    root.classList.add('is-primed');

    if (!('IntersectionObserver' in window)) {
      // No observer support: just reveal immediately.
      reveal(root);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          reveal(entries[i].target);
          observer.unobserve(entries[i].target);
          observer.disconnect();
          return;
        }
      }
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

    observer.observe(root);
  }

  function init() {
    var roots = document.querySelectorAll('[data-centauri-c12-metrics]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init inside the Theme Editor when a section/block is re-rendered.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
